import { GET_TOTEMS } from 'data/queries';
import { TotemDeletedCacheHandlerParams } from 'types/cache.types';
import { TotemFragmentFragment as Totem } from 'data/__generated__';

export function totemDeletedCacheHandler({ apolloClient, deletedTotemId }: TotemDeletedCacheHandlerParams): void {
    const { totemsOfUser } = apolloClient.readQuery({
        query: GET_TOTEMS,
    }) as { totemsOfUser: Totem[] };
    apolloClient.writeQuery({
        query: GET_TOTEMS,
        data: {
            totemsOfUser: totemsOfUser.filter((totem) => totem._id !== deletedTotemId),
        },
    });
}
